// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/coins/v1/types.proto (package creativefabrica.coins.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/coins/v1/types.proto.
 */
export const file_creativefabrica_coins_v1_types: GenFile = /*@__PURE__*/
  fileDesc("CiRjcmVhdGl2ZWZhYnJpY2EvY29pbnMvdjEvdHlwZXMucHJvdG8SGGNyZWF0aXZlZmFicmljYS5jb2lucy52MSLAAgoJQ29pbkVycm9yEjUKBGNvZGUYASABKA4yJy5jcmVhdGl2ZWZhYnJpY2EuY29pbnMudjEuQ29pbkVycm9yQ29kZRIPCgdtZXNzYWdlGAIgASgJEk8KFXBheW1lbnRfaW50ZW50X3Jlc3VsdBgDIAEoCzIrLmNyZWF0aXZlZmFicmljYS5jb2lucy52MS5Db2luUGF5bWVudEludGVudEgAiAEBEmIKGWluc3VmZmljaWVudF9mdW5kX2RldGFpbHMYBCABKAsyOi5jcmVhdGl2ZWZhYnJpY2EuY29pbnMudjEuQ29pbkVycm9ySW5zdWZmaWNpZW50RnVuZERldGFpbHNIAYgBAUIYChZfcGF5bWVudF9pbnRlbnRfcmVzdWx0QhwKGl9pbnN1ZmZpY2llbnRfZnVuZF9kZXRhaWxzIlUKIENvaW5FcnJvckluc3VmZmljaWVudEZ1bmREZXRhaWxzEhcKD2N1cnJlbnRfYmFsYW5jZRgBIAEoAxIYChByZXF1aXJlZF9iYWxhbmNlGAIgASgDIosBChFDb2luUGF5bWVudEludGVudBITCgt1c2VyX2Jhbm5lZBgBIAEoCBIeChZzdHJpcGVfaW52b2ljZV9wYXlfdXJsGAIgASgJEkEKBnN0YXR1cxgDIAEoDjIxLmNyZWF0aXZlZmFicmljYS5jb2lucy52MS5Db2luUGF5bWVudEludGVudFN0YXR1cyq6AwoNQ29pbkVycm9yQ29kZRIfChtDT0lOX0VSUk9SX0NPREVfVU5TUEVDSUZJRUQQABIyCi5DT0lOX0VSUk9SX0NPREVfTUlTU0lOR19BSV9TVFVESU9fU1VCU0NSSVBUSU9OEAESJgoiQ09JTl9FUlJPUl9DT0RFX0lOU1VGRklDSUVOVF9GVU5EUxACEiQKIENPSU5fRVJST1JfQ09ERV9QQVlNRU5UX1JFUVVJUkVEEAMSQAo8Q09JTl9FUlJPUl9DT0RFX1NVQlNDUklQVElPTl9UUklBTF9UT19BQ1RJVkFUSU9OX0lOX1BST0dSRVNTEAQSJAogQ09JTl9FUlJPUl9DT0RFX1RSSUFMSVNUX1RJUFBJTkcQBRI5CjVDT0lOX0VSUk9SX0NPREVfTUlTU0lOR19TVFVESU9fVU5MSU1JVEVEX1NVQlNDUklQVElPThAGEjMKL0NPSU5fRVJST1JfQ09ERV9NSVNTSU5HX0FMTF9BQ0NFU1NfU1VCU0NSSVBUSU9OEAcSLgoqQ09JTl9FUlJPUl9DT0RFX1BBSURfU1VCU0NSSVBUSU9OX1JFUVVJUkVEEAgq8QEKF0NvaW5QYXltZW50SW50ZW50U3RhdHVzEioKJkNPSU5fUEFZTUVOVF9JTlRFTlRfU1RBVFVTX1VOU1BFQ0lGSUVEEAASKAokQ09JTl9QQVlNRU5UX0lOVEVOVF9TVEFUVVNfU1VDQ0VFREVEEAESJQohQ09JTl9QQVlNRU5UX0lOVEVOVF9TVEFUVVNfRkFJTEVEEAISKQolQ09JTl9QQVlNRU5UX0lOVEVOVF9TVEFUVVNfUFJPQ0VTU0lORxADEi4KKkNPSU5fUEFZTUVOVF9JTlRFTlRfU1RBVFVTX1JFUVVJUkVTX0FDVElPThAEQk5aTGdpdGh1Yi5jb20vY3JlYXRpdmVmYWJyaWNhL3NjaGVtYXMvcGtnL2dlbi9jcmVhdGl2ZWZhYnJpY2EvY29pbnMvdjE7Y29pbnNfdjFiBnByb3RvMw");

/**
 * @generated from message creativefabrica.coins.v1.CoinError
 */
export type CoinError = Message<"creativefabrica.coins.v1.CoinError"> & {
  /**
   * @generated from field: creativefabrica.coins.v1.CoinErrorCode code = 1;
   */
  code: CoinErrorCode;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: optional creativefabrica.coins.v1.CoinPaymentIntent payment_intent_result = 3;
   */
  paymentIntentResult?: CoinPaymentIntent | undefined;

  /**
   * @generated from field: optional creativefabrica.coins.v1.CoinErrorInsufficientFundDetails insufficient_fund_details = 4;
   */
  insufficientFundDetails?: CoinErrorInsufficientFundDetails | undefined;
};

/**
 * @generated from message creativefabrica.coins.v1.CoinError
 */
export type CoinErrorJson = {
  /**
   * @generated from field: creativefabrica.coins.v1.CoinErrorCode code = 1;
   */
  code?: CoinErrorCodeJson;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: optional creativefabrica.coins.v1.CoinPaymentIntent payment_intent_result = 3;
   */
  paymentIntentResult?: CoinPaymentIntentJson;

  /**
   * @generated from field: optional creativefabrica.coins.v1.CoinErrorInsufficientFundDetails insufficient_fund_details = 4;
   */
  insufficientFundDetails?: CoinErrorInsufficientFundDetailsJson;
};

/**
 * Describes the message creativefabrica.coins.v1.CoinError.
 * Use `create(CoinErrorSchema)` to create a new message.
 */
export const CoinErrorSchema: GenMessage<CoinError, {jsonType: CoinErrorJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v1_types, 0);

/**
 * @generated from message creativefabrica.coins.v1.CoinErrorInsufficientFundDetails
 */
export type CoinErrorInsufficientFundDetails = Message<"creativefabrica.coins.v1.CoinErrorInsufficientFundDetails"> & {
  /**
   * @generated from field: int64 current_balance = 1;
   */
  currentBalance: bigint;

  /**
   * @generated from field: int64 required_balance = 2;
   */
  requiredBalance: bigint;
};

/**
 * @generated from message creativefabrica.coins.v1.CoinErrorInsufficientFundDetails
 */
export type CoinErrorInsufficientFundDetailsJson = {
  /**
   * @generated from field: int64 current_balance = 1;
   */
  currentBalance?: string;

  /**
   * @generated from field: int64 required_balance = 2;
   */
  requiredBalance?: string;
};

/**
 * Describes the message creativefabrica.coins.v1.CoinErrorInsufficientFundDetails.
 * Use `create(CoinErrorInsufficientFundDetailsSchema)` to create a new message.
 */
export const CoinErrorInsufficientFundDetailsSchema: GenMessage<CoinErrorInsufficientFundDetails, {jsonType: CoinErrorInsufficientFundDetailsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v1_types, 1);

/**
 * @generated from message creativefabrica.coins.v1.CoinPaymentIntent
 */
export type CoinPaymentIntent = Message<"creativefabrica.coins.v1.CoinPaymentIntent"> & {
  /**
   * @generated from field: bool user_banned = 1;
   */
  userBanned: boolean;

  /**
   * @generated from field: string stripe_invoice_pay_url = 2;
   */
  stripeInvoicePayUrl: string;

  /**
   * @generated from field: creativefabrica.coins.v1.CoinPaymentIntentStatus status = 3;
   */
  status: CoinPaymentIntentStatus;
};

/**
 * @generated from message creativefabrica.coins.v1.CoinPaymentIntent
 */
export type CoinPaymentIntentJson = {
  /**
   * @generated from field: bool user_banned = 1;
   */
  userBanned?: boolean;

  /**
   * @generated from field: string stripe_invoice_pay_url = 2;
   */
  stripeInvoicePayUrl?: string;

  /**
   * @generated from field: creativefabrica.coins.v1.CoinPaymentIntentStatus status = 3;
   */
  status?: CoinPaymentIntentStatusJson;
};

/**
 * Describes the message creativefabrica.coins.v1.CoinPaymentIntent.
 * Use `create(CoinPaymentIntentSchema)` to create a new message.
 */
export const CoinPaymentIntentSchema: GenMessage<CoinPaymentIntent, {jsonType: CoinPaymentIntentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v1_types, 2);

/**
 * @generated from enum creativefabrica.coins.v1.CoinErrorCode
 */
export enum CoinErrorCode {
  /**
   * @generated from enum value: COIN_ERROR_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COIN_ERROR_CODE_MISSING_AI_STUDIO_SUBSCRIPTION = 1;
   */
  MISSING_AI_STUDIO_SUBSCRIPTION = 1,

  /**
   * @generated from enum value: COIN_ERROR_CODE_INSUFFICIENT_FUNDS = 2;
   */
  INSUFFICIENT_FUNDS = 2,

  /**
   * @generated from enum value: COIN_ERROR_CODE_PAYMENT_REQUIRED = 3;
   */
  PAYMENT_REQUIRED = 3,

  /**
   * @generated from enum value: COIN_ERROR_CODE_SUBSCRIPTION_TRIAL_TO_ACTIVATION_IN_PROGRESS = 4;
   */
  SUBSCRIPTION_TRIAL_TO_ACTIVATION_IN_PROGRESS = 4,

  /**
   * @generated from enum value: COIN_ERROR_CODE_TRIALIST_TIPPING = 5;
   */
  TRIALIST_TIPPING = 5,

  /**
   * @generated from enum value: COIN_ERROR_CODE_MISSING_STUDIO_UNLIMITED_SUBSCRIPTION = 6;
   */
  MISSING_STUDIO_UNLIMITED_SUBSCRIPTION = 6,

  /**
   * @generated from enum value: COIN_ERROR_CODE_MISSING_ALL_ACCESS_SUBSCRIPTION = 7;
   */
  MISSING_ALL_ACCESS_SUBSCRIPTION = 7,

  /**
   * The action needs a paid, non-trial Studio subscription (Studio AI, Studio
   * Unlimited, Team or a Team seat). Unlike MISSING_AI_STUDIO_SUBSCRIPTION a
   * trial does not satisfy it: the user subscribes, or activates their trial.
   * Services-mcp and services-workflows answer this on every call.
   *
   * @generated from enum value: COIN_ERROR_CODE_PAID_SUBSCRIPTION_REQUIRED = 8;
   */
  PAID_SUBSCRIPTION_REQUIRED = 8,
}

/**
 * @generated from enum creativefabrica.coins.v1.CoinErrorCode
 */
export type CoinErrorCodeJson = "COIN_ERROR_CODE_UNSPECIFIED" | "COIN_ERROR_CODE_MISSING_AI_STUDIO_SUBSCRIPTION" | "COIN_ERROR_CODE_INSUFFICIENT_FUNDS" | "COIN_ERROR_CODE_PAYMENT_REQUIRED" | "COIN_ERROR_CODE_SUBSCRIPTION_TRIAL_TO_ACTIVATION_IN_PROGRESS" | "COIN_ERROR_CODE_TRIALIST_TIPPING" | "COIN_ERROR_CODE_MISSING_STUDIO_UNLIMITED_SUBSCRIPTION" | "COIN_ERROR_CODE_MISSING_ALL_ACCESS_SUBSCRIPTION" | "COIN_ERROR_CODE_PAID_SUBSCRIPTION_REQUIRED";

/**
 * Describes the enum creativefabrica.coins.v1.CoinErrorCode.
 */
export const CoinErrorCodeSchema: GenEnum<CoinErrorCode, CoinErrorCodeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_coins_v1_types, 0);

/**
 * @generated from enum creativefabrica.coins.v1.CoinPaymentIntentStatus
 */
export enum CoinPaymentIntentStatus {
  /**
   * @generated from enum value: COIN_PAYMENT_INTENT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COIN_PAYMENT_INTENT_STATUS_SUCCEEDED = 1;
   */
  SUCCEEDED = 1,

  /**
   * @generated from enum value: COIN_PAYMENT_INTENT_STATUS_FAILED = 2;
   */
  FAILED = 2,

  /**
   * @generated from enum value: COIN_PAYMENT_INTENT_STATUS_PROCESSING = 3;
   */
  PROCESSING = 3,

  /**
   * @generated from enum value: COIN_PAYMENT_INTENT_STATUS_REQUIRES_ACTION = 4;
   */
  REQUIRES_ACTION = 4,
}

/**
 * @generated from enum creativefabrica.coins.v1.CoinPaymentIntentStatus
 */
export type CoinPaymentIntentStatusJson = "COIN_PAYMENT_INTENT_STATUS_UNSPECIFIED" | "COIN_PAYMENT_INTENT_STATUS_SUCCEEDED" | "COIN_PAYMENT_INTENT_STATUS_FAILED" | "COIN_PAYMENT_INTENT_STATUS_PROCESSING" | "COIN_PAYMENT_INTENT_STATUS_REQUIRES_ACTION";

/**
 * Describes the enum creativefabrica.coins.v1.CoinPaymentIntentStatus.
 */
export const CoinPaymentIntentStatusSchema: GenEnum<CoinPaymentIntentStatus, CoinPaymentIntentStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_coins_v1_types, 1);

